import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      questions: 'profile/dashboard/questions',
      appointments: 'profile/dashboard/appointments'
    }),

    activeAppointments() {
      const sortByDate = (left, right) => new Date(right.dateCreated) - new Date(left.dateCreated);

      const priority1 = this.appointments
        .filter(
          item =>
            item.aggregatedStatusName === 'ORDER_ORDERED_ON_DATETIME_OF_ORDERING' &&
            new Date(item.consultingAmbulanceVisitDate) > new Date()
        )
        .sort(sortByDate);
      const priority2 = this.appointments
        .filter(
          item =>
            ['ORDER_DURING_OFFICE_HOURS', 'ORDER_DONE_CONTACTS_SENT'].indexOf(
              item.aggregatedStatusName
            ) !== -1
        )
        .sort(sortByDate);
      const priority3 = this.appointments
        .filter(
          item =>
            ['ORDER_WE_WILL_CALL', 'ORDER_LOOKING_SUITABLE_DOCTOR'].indexOf(
              item.aggregatedStatusName
            ) !== -1
        )
        .sort(sortByDate);
      return [...priority1, ...priority2, ...priority3];
    },

    activeQuestions() {
      const sortByDate = (left, right) => new Date(right.dateCreated) - new Date(left.dateCreated);

      const priority1 = this.questions
        .filter(
          item =>
            item.aggregatedStatusName === 'QUESTION_MOVED_TO_URGENT_ORDER' && !item.seenByWebuser
        )
        .sort(sortByDate);
      const priority2 = this.questions
        .filter(
          item =>
            [
              'QUESTION_ANSWERED',
              'QUESTION_TRANSFER_TO_APPOINTMENT',
              'QUESTION_MOVED_TO_SPECIALIST_WAITING_ANSWER'
            ].indexOf(item.aggregatedStatusName) !== -1 && !item.seenByWebuser
        )
        .sort(sortByDate);
      const priority3 = this.questions
        .filter(
          item =>
            item.aggregatedStatusName === 'QUESTION_CREATED_WAITING_GP_ANSWER' ||
            item.aggregatedStatusName === 'QUESTION_INTERPRETATION_CREATED' ||
            item.aggregatedStatusName === 'QUESTION_INTERPRETATION_WAIT_FOR_RESULT' ||
            (item.aggregatedStatusName === 'QUESTION_MOVED_TO_SPECIALIST_WAITING_ANSWER' &&
              item.seenByWebuser !== null)
        )
        .sort(sortByDate);
      return [...priority1, ...priority2, ...priority3];
    }
  }
};
